module.exports = __webpack_public_path__ + "img/sticker_16.63489933.svg";